import {EditOutlined, ImportOutlined} from "@ant-design/icons";
import {Button, Tooltip} from "antd";
import {FoodName} from "app/food/FoodSummary";
import {
  IFoodFieldsFragment,
  IRecipeIngredientFieldsFragment,
  IUserIngredientFieldsFragment
} from "app/gql/graphqlSchema";
import {UnreachableCaseError} from "ts-essentials";

interface IProps {
  ingredient: IRecipeIngredientFieldsFragment;
  onEdit: (userIngredient: IUserIngredientFieldsFragment) => void;
  onImport: (food: IFoodFieldsFragment) => void;
}

export const EditIngredientButton = ({ingredient, onEdit, onImport}: IProps) => {
  if (ingredient.__typename === "ReferenceRecipeIngredient") {
    return (
      <Tooltip
        title={
          <>
            Create new custom ingredient from <FoodName className="font-bold" ingredient={ingredient} />
          </>
        }
      >
        <Button icon={<ImportOutlined />} onClick={() => onImport(ingredient.food)} variant="solid" />
      </Tooltip>
    );
  } else if (ingredient.__typename === "UserRecipeIngredient") {
    return (
      <Tooltip
        title={
          <>
            Edit <FoodName className="font-bold" ingredient={ingredient} />
          </>
        }
      >
        <Button
          color="primary"
          icon={<EditOutlined />}
          onClick={() => onEdit(ingredient.userIngredient)}
          variant="solid"
        />
      </Tooltip>
    );
  } else {
    throw new UnreachableCaseError(ingredient);
  }
};
